"use client";

import styles from "@/styles/newsletters/index.module.scss";
import { useState } from "react";
import Link from "next/link";
import myAccountApi from "@/service/modules/myAccountApi";
import { Button, Input, Form } from "react-vant";
import { toast } from "@/components/global/Toast";

export default function NewslettersIndexClient() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values: {
    email: string;
    month?: string;
    year?: string;
  }) => {
    try {
      setLoading(true);

      const dataObj = {
        email: values.email,
        birthm: values.month || '',
        birthy: values.year || '',
      };

      const finnalParams = Object.fromEntries(
        Object.entries(dataObj).filter(
          ([, value]) => value !== null && value !== ""
        )
      );

      const res = await myAccountApi.subscribe(finnalParams);
      setLoading(false);
      const { location } = res.data;
      if (location) {
        window.location.href = location;
      }
    } catch {
      setLoading(false);
      toast.show("Subscription failed, please try again");
    }
  };

  return (
    <div className={styles["page-newsletters-index"]}>
      <div className={styles["page-title"]}>
        Required Information
      </div>

      <Form
        form={form}
        onFinish={onFinish}
        layout={"vertical"}
        footer={
          <div>
            <Button
              round
              nativeType="submit"
              type="primary"
              style={{ fontWeight: "700" }}
              loading={loading}
              loadingText="Subscribe Now!"
              block
            >
              Subscribe Now!
            </Button>

            <div className={styles['unsubscribe-text']}>
              (You can unsubscribe at anytime)
              <Link href="/newsletters/frontunsub" className={styles['link']}>
                click here
              </Link>
            </div>
          </div>
        }
      >
        <Form.Item
          rules={[
            { required: true, message: `Please input email !` },
            { type: 'email', message: `Error email !` },
          ]}
          name='email'
          label={<span className={styles['required-label']}>Email</span>}
        >
          <Input 
            placeholder='Email address' 
            maxLength={225} 
          />
        </Form.Item>

        <div className={styles['dob-form-box']}>
          <Form.Item
            name='month'
            label='DOB:'
            style={{ marginRight: '10px' }}
          >
            <select style={{ padding: '0 !important' }}>
              <option value="" >Month</option>
              {Array.from({ length: 12 }, (_, i) => (
                <option key={i + 1} value={String(i + 1).padStart(2, '0')}>
                  {String(i + 1).padStart(2, '0')}
                </option>
              ))}
            </select>
          </Form.Item>

          <Form.Item
            name='year'
            label=' '
          >
            <select style={{ padding: '0 !important' }}>
              <option value="">Year</option>
              {Array.from({ length: 100 }, (_, i) => {
                const year = new Date().getFullYear() - i;
                return (
                  <option key={year} value={year}>
                    {year}
                  </option>
                );
              })}
            </select>
          </Form.Item>
        </div>
        <div className={styles['dob-form-tips']}>
          You may receive a birthday gift from us!
        </div>
      </Form>
    </div>
  );
}
